import React, {useState, useEffect, useRef} from "react";
import moment from "moment";
import axios from "axios";
import LoaderForSearch from "../../Common/LoaderForSearch";
import {AESEncryption, ApiResDecrypt, noDataFound} from "../../../CommonMethhods/CommonMethods";

function RejectionListComp(props) {
    const {URL} = props;
    const fromDateSet = () => {
        const current = new Date();
        const CurrentYear = current.getFullYear();
        const CurrentMonth = current.getMonth();
        let newYear;
        if (CurrentMonth < 4) {
            newYear = `${CurrentYear - 1}-01-04`;
        } else {
            newYear = `${CurrentYear}-01-04`;
        }
        return newYear;
    };
    const toDateSet = () => {
        const current = new Date();

        let month = current.getMonth() + 1,
            day = current.getDate();

        if (month < 10) {
            month = `0${month}`;
        }
        if (day < 10) {
            day = `0${day}`;
        }
        const date = `${current.getFullYear()}-${month}-${day}`;
        return date;
    };
    const [fromDate, setFromDate] = useState(fromDateSet());
    const [error, setError] = useState("");
    const [toDate, setToDate] = useState(toDateSet());
    const [rejectCustomer, setRejectCustomer] = useState([]);
    const [page, setPage] = useState(1);
    const [tableError, setTableError] = useState(false);
    const [scrollLoader, setScrollLoader] = useState(false);
    const [count, setCount] = useState();
    const rejectionListSearch = useRef("");
    const storeToken = localStorage.getItem("ssoToken");
    if (storeToken == null) {
        window.location.replace("/");
        // localStorage.clear("");
    }

    useEffect(() => {
        RejectedCustomers("grid");
    }, [page]);

    const RejectedCustomers = async (filetype, pageSize = 10) => {
        try {
            let payload = {
                fromDate: fromDate,
                toDate: toDate,
                search: filetype === "excel" ? "" : rejectionListSearch.current.value,
                pageSize: pageSize,
                pageNo: page,
                fileType: filetype,
            };
            let encPayload = AESEncryption(payload);
            const encResponse = await axios.post(`${URL}`, encPayload, {
                headers: {
                    "content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    reserv: 1,
                },
                mode: "no-cors",
            });
            let response = ApiResDecrypt(encResponse.data);
            const res = response.data;
            const data = response;
            setTableError(data.message);
            if (res) {
                if (filetype == "grid") {
                    setCount(res.totalCount);
                    setTableError(false);
                    if (page > 1) {
                        setRejectCustomer((prev) => {
                            return [...prev, ...res.rejectedClients];
                        });
                    } else {
                        setRejectCustomer(res.rejectedClients);
                    }
                } else {
                    window.open(res, "_blank", "noopener,noreferrer");
                }
            }
        } catch (err) {
            setTableError("Server failed please try again later");
        } finally {
            setScrollLoader(false);
        }
    };
    const handleOnClick = (e) => {
        setPage(1);
        setRejectCustomer([]);
        if (e.target.value) {
            setError("");
            if (fromDate.length > 0 && toDate.length > 0) {
                RejectedCustomers("grid", 10);
                if (compareDate(fromDate) && compareDate(toDate) && checkDateRange(fromDate, toDate)) {
                    setError("");
                }
            }
        }
    };

    const compareDate = (date) => {
        const currentDate = new Date();
        const inputDate = new Date(date);
        if (inputDate <= currentDate) {
            return true;
        } else {
            return false;
        }
    };

    if (fromDate == "" || toDate == "") {
        const current = new Date();
        const CurrentYear = current.getFullYear();
        const CurrentMonth = current.getMonth();
        if (CurrentMonth < 4) {
            const newYear = `04-01-${CurrentYear - 1}`;
            const date = `${current.getMonth() + 1}-${current.getDate()}-${current.getFullYear()}`;
            const date1 = moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
            setFromDate(newYear);
            setToDate(date1);
        } else {
            const newYear = `04-01-${CurrentYear}`;
            const date = `${current.getMonth() + 1}-${current.getDate()}-${current.getFullYear()}`;
            const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
            setFromDate(newYear);
            setToDate(date1);
        }
    }

    const handleFromDateChange = (e) => {
        let c = e.target.value;
        setFromDate(c);
        setError("");
    };
    const checkDateRange = (fromDate, toDate) => {
        const checkFromDate = new Date(fromDate);
        const checkToDate = new Date(toDate);
        if (checkFromDate <= checkToDate) {
            return true;
        } else {
            return false;
        }
    };
    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");
    const handleToDateChange = (e) => {
        let c = e.target.value;
        setToDate(c);
        setError("");
    };

    const showTableData = (rejectCustomer) => {
        return rejectCustomer.map((item, key) => {
            return (
                <tr key={key}>
                    <td>{item.ekycId === "" || undefined || null ? "-" : item.ekycId}</td>
                    <td>{item.name === "" || undefined || null ? "-" : item.name}</td>
                    <td>{item.mobile === "" || undefined || null ? "-" : item.mobile}</td>
                    <td>{item.panNo === "" || undefined || null ? "-" : item.panNo}</td>
                    <td>
                        {item.finalRejectedOn.split("T")[0] === "" || undefined || null
                            ? "-"
                            : item.finalRejectedOn.split("T")[0]}
                    </td>
                    <td>{item.finalRejectedBy === "" || undefined || null ? "-" : item.finalRejectedBy}</td>
                    <td>{item.finalRejectionStatus === "" || undefined || null ? "-" : item.finalRejectionStatus}</td>
                    <td>{item.reason === "" || undefined || null ? "-" : item.reason}</td>
                </tr>
            );
        });
    };
    function handleChange(e) {
        e.target.value = e.target.value.toUpperCase();
        setRejectCustomer([]);
        setPage(1);
        RejectedCustomers("grid", 10);
    }

    const handleScroll = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
            if (!(count <= 10 * page)) {
                setPage((prev) => prev + 1);
                setScrollLoader(true);
            }
        }
    };

    return (
        <>
            <div className="rejection-list">
                <div className="row rejection-list-input">
                    <div className="col-md-4 col-sm-4 form-group">
                        <label htmlFor="to" className="form-label">
                            Start Date
                        </label>
                        <input
                            type="date"
                            placeholder="dd/mm/yyyy"
                            className="rejectdate form-control"
                            onChange={handleFromDateChange}
                            defaultValue={fromDateSet(fromDate)}
                            id="FromDate"
                            max={DateReverse}
                        />
                        <span className="search-error">{error}</span>
                    </div>

                    <div className="col-md-4 col-sm-4  form-group">
                        <label htmlFor="to" className="form-label">
                            End Date
                        </label>
                        <input
                            type="date"
                            placeholder="DD/MM/YYYY"
                            className="endrejectdate form-control"
                            onChange={handleToDateChange}
                            defaultValue={toDateSet(toDate)}
                            id="ToDate"
                            max={DateReverse}
                        />
                        <div className="search-error">{error}</div>
                    </div>
                    <div className="col-md-2 col-sm-2">
                        <button className="send-message" value="grid" onClick={(e) => handleOnClick(e)}>
                            Submit
                        </button>
                    </div>
                    <div className="col-md-2 col-sm-2">
                        <button
                            className="generate-btn text-green"
                            value="excel"
                            // onClick={(e) => handleOnClick(e)}
                            onClick={(e) => RejectedCustomers("excel", -1)}
                        >
                            <>
                                <span className="icon-excelsvg"></span>
                                {"Excel"}
                            </>
                        </button>
                    </div>
                </div>
                <div className="form-group search-wrapper" id="search-mob">
                    <div className="for-position">
                        <input
                            type="text"
                            name="search-text"
                            id="SearchInput"
                            className="input-st"
                            placeholder="Search here..."
                            autoComplete="off"
                            ref={rejectionListSearch}
                            onChange={handleChange}
                            onInput={(e) => {
                                const start = e.target.selectionStart;
                                const end = e.target.selectionEnd;
                                let input = e.target.value;
                                input = input
                                    .toUpperCase()
                                    .replace(/[^A-Z0-9\s]/g, "")
                                    .replace(/\s+/g, " ")
                                    .trimStart()
                                    .slice(0, 100);

                                e.target.value = input;
                                e.target.setSelectionRange(start, end);
                            }}
                        />
                    </div>
                </div>
            </div>

            {rejectCustomer && rejectCustomer ? (
                <div className="mt-4">
                    <>
                        <div className="search-box">
                            <form action="#" method="post">
                                <div className="form-group" id="search-mob"></div>
                            </form>
                        </div>
                        <div className="for-grid-section">
                            <div className="table-responsive scroll-table report-table-wrapper">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>EKYC_Id</th>
                                            <th>Name</th>
                                            <th>Mobile</th>
                                            <th>Pan No</th>

                                            <th>Rejected On</th>
                                            <th>Rejected By</th>
                                            <th>Status</th>
                                            <th>Reason</th>
                                        </tr>
                                    </thead>
                                    {tableError ? (
                                        <tbody>{noDataFound(tableError)}</tbody>
                                    ) : (
                                        <tbody onScroll={(e) => handleScroll(e)}>
                                            {showTableData(rejectCustomer)}
                                            {scrollLoader && (
                                                <div className="loader-center">
                                                    <LoaderForSearch />
                                                </div>
                                            )}
                                        </tbody>
                                    )}
                                </table>
                            </div>
                        </div>
                    </>
                </div>
            ) : (
                ""
            )}
        </>
    );
}

export default RejectionListComp;
